import React from 'react';
import { ErrorMessage, FieldProps, FormikValues } from 'formik';
import { Field } from '~/components/Formik';
import { DatePicker } from '~/components/Form';
import { getAcceptableDates, getActiveStartDate } from '~/util';

interface ActionDatePickerProps {
    name: string;
    detail: QualityMeasureDetailType;
    checkboxId: string;
    inputName: string;
    readOnly: boolean;
    submissionAnswer?: SubmissionAnswerType;
    formik: FormikValues;
}
export function ActionDatePicker({
    name,
    detail,
    checkboxId,
    inputName,
    readOnly,
    submissionAnswer,
    formik,
}: ActionDatePickerProps) {
    const acceptableDates = getAcceptableDates(detail);

    function validate(value: Date) {
        if (!formik.values[checkboxId]) return '';
        if (!value) {
            // If this input has an answer, make sure it also has a date
            if (formik.values[inputName] === '' || formik.values[inputName]) {
                return 'Date is required.';
            }
            return '';
        }

        if (value < acceptableDates?.min || value > acceptableDates?.max) {
            return 'Date must be within Acceptable Date range';
        }
        return '';
    }

    function handleChange(date: Date) {
        // Set touched and value manually since we don't have the onChange event
        formik.setFieldTouched(name);
        formik.setFieldValue(name, date);
    }

    return (
        <Field name={name} validate={validate}>
            {({ field, meta }: FieldProps) => (
                <>
                    <DatePicker
                        {...field}
                        // overwrite formik validation onBlur
                        onBlur={() => {}}
                        onChange={handleChange}
                        minDate={acceptableDates?.min}
                        maxDate={acceptableDates?.max}
                        disabled={readOnly || !formik.values[checkboxId]}
                        defaultActiveStartDate={
                            getActiveStartDate(detail, submissionAnswer) || undefined
                        }
                        className={meta.error && meta.touched ? 'is-invalid ' : ''}
                    />
                    <div className="text-danger">
                        <ErrorMessage name={field.name} />
                    </div>
                </>
            )}
        </Field>
    );
}
